import React, { Component } from "react";
import DropdownTreeSelect from "react-dropdown-tree-select";
import isEqual from "lodash/isEqual";

export default class DropDownContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { data: props.data };
  }

  // revert to this code the one below didn't work
  //componentWillReceiveProps = nextProps => {
  //   if (!isEqual(nextProps.data, this.state.data)) {
  //     this.setState({ data: nextProps.data });
  //   }
  // };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (!isEqual(nextProps.data, prevState.data)) {
      return { data: nextProps.data };
    }
    return null;
  }

  shouldComponentUpdate = nextProps => {
    if (nextProps.ownProps.activeLayerName) {
      let nextLayer = nextProps.ownProps.activeLayerName;
      let previousLayer = this.props.ownProps.activeLayerName;
      // comment out filtering by countries for now
      // if (nextProps.selectedCountries === "" && nextLayer !== previousLayer) {
      //   return true;
      // }
      if (nextProps.selectedRwcRegions === "" && nextLayer !== previousLayer) {
        return true;
      }
    }
    return !isEqual(nextProps.data, this.state.data);
  };

  render() {
    const { data, ...rest } = this.props;
    return <DropdownTreeSelect data={this.state.data} {...rest} />;
  }
}
